// extracted by mini-css-extract-plugin
module.exports = {"CommunityGrid":"CommunityGrid_CommunityGrid__TgH1r","SmallerGrid":"CommunityGrid_SmallerGrid__5V1pB"};